import { render, staticRenderFns } from "./VPNList.vue?vue&type=template&id=5016fcd8&"
import script from "./VPNList.vue?vue&type=script&lang=js&"
export * from "./VPNList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports